import { render, staticRenderFns } from "./IssueExcuseDutyModal.vue?vue&type=template&id=47754da6&"
import script from "./IssueExcuseDutyModal.vue?vue&type=script&lang=js&"
export * from "./IssueExcuseDutyModal.vue?vue&type=script&lang=js&"
import style0 from "./IssueExcuseDutyModal.vue?vue&type=style&index=0&id=47754da6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports